import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Seo, breadcrumbSchema } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { PageHero, SectionHead, CtaBand, ServiceCard } from "@/components/Blocks";
import { SERVICES, CATALOGUE } from "@/data/services";

export default function Services() {
  const crumbs = [["Home", "/"], ["Services", "/services"]];
  return (
    <>
      <Seo title="Manufacturing Software & Industrial Digital Solutions | Industrix" description="Industrial website design, manufacturing software, ERP, CRM, production systems, B2B portals, mobile apps, IoT, AI automation, SEO and cloud services for manufacturers." path="/services" jsonLd={[breadcrumbSchema(crumbs)]} />
      <PageHero crumbs={crumbs} eyebrow="Service catalogue" lines={["Manufacturing Software", "& Industrial Digital", "Solutions"]} intro="Twelve service areas that cover the full digital needs of a manufacturing or industrial business, from the website buyers see first to the systems that run the plant. Every engagement is scoped to your requirements after discovery." img="cnc" imgAlt="CNC machine cutting metal in a precision engineering workshop" />

      <section className="wrap py-24 lg:py-32" data-testid="services-grid">
        <SectionHead eyebrow="Core services" title="Twelve ways we help industrial businesses" />
        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => <Reveal key={s.slug} delay={(i % 3) * 0.06} className="flex"><ServiceCard s={s} i={i} /></Reveal>)}
        </div>
      </section>

      <section className="border-t border-stone bg-white py-24 lg:py-32" data-testid="services-catalogue">
        <div className="wrap">
          <SectionHead eyebrow="Detailed catalogue" title="Everything we deliver, by category" lead="Each category links to the most relevant service page with features, approach and FAQs." />
          <div className="mt-16 grid gap-x-12 gap-y-16 md:grid-cols-2">
            {CATALOGUE.map((c) => (
              <Reveal key={c.key} className="border-t-2 border-charcoal pt-6" >
                <div id={`category-${c.key.toLowerCase()}`} className="flex items-baseline justify-between gap-4">
                  <h3 className="font-display text-2xl font-bold"><span className="mr-3 font-mono text-sm text-rust-ink">{c.key}.</span>{c.title}</h3>
                </div>
                {c.note && <p className="mt-3 text-[13px] leading-relaxed text-graphite">{c.note}</p>}
                <ul className="mt-5 grid gap-x-6 sm:grid-cols-2">
                  {c.items.map((it) => <li key={it} className="border-b border-stone py-2.5 text-[14px] text-graphite">{it}</li>)}
                </ul>
                <Link to={`/services/${c.slug}`} className="mt-5 inline-flex items-center gap-1.5 text-[13px] font-semibold text-rust-ink hover:text-charcoal" data-testid={`catalogue-link-${c.key}`}>
                  Explore {c.title} <ArrowUpRight className="h-4 w-4" />
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
